import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.ActivitiesLobby);

  return (
    <Stack gap={'16px'}>
      <Typography component={'h1'} variant='h2'>
        {dictionary.title}
      </Typography>
      <Typography variant='body3'>{dictionary.subtitle}</Typography>
    </Stack>
  );
};
